// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3pvt7","inputWrap":"Table_inputWrap__3EKhX","col":"Table_col__3ZVNp","bmiTooltip":"Table_bmiTooltip__2m-I-"};